import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Pinterest24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M18.971 8.707c-.318-4.062-3.93-5.214-3.93-5.214-3.958-1.4-6.865.627-6.865.627-3.983 2.524-3.09 6.43-3.09 6.43.43 2.492 2.107 2.898 2.107 2.898.33.101.438-.237.438-.237l.267-1.055c.033-.133-.094-.274-.094-.274l-.224-.266c-.6-.857-.56-1.93-.56-1.93.151-2.812 1.908-3.975 2.783-4.407.875-.425 3.536-1.098 5.466.569 1.93 1.667.908 5.22.908 5.22-.384 1.534-1.334 2.47-1.334 2.47-1.19 1.084-2.318.59-2.318.59-1.301-.546-1.015-1.789-1.015-1.789l.108-.432.239-.828s.65-1.71.589-2.675c-.062-.961-.752-1.624-1.93-1.3-1.18.324-1.41 1.952-1.41 1.952-.192 1.382.148 2.052.289 2.268l-.015.01-1.236 5.207c-.307 1.31-.307 2.06-.282 2.834.025.774.155 1.551.155 1.551.116.166.253 0 .253 0 1.436-1.821 1.783-3.089 1.783-3.089l.802-3.118c.47.756 1.16.998 1.16.998 2.55 1.083 4.762-.976 4.762-.976s2.52-1.973 2.194-6.034z"
      fill="#010101"
      fillRule="evenodd"
    />
  </svg>
);

export default Pinterest24;
